import { Injectable } from '@angular/core';
import { HttpService } from '../../';

@Injectable({
  providedIn: 'root'
})
export class BelairTestPaymentService {

  constructor(private http: HttpService) { }

  makePayment(BELAIR_TEST_PG_INFO: any,) {
    const BELAIR_TEST_ = BELAIR_TEST_PG_INFO;
    const body = new URLSearchParams();
    body.set("id", '48793');
    body.set("payment[payment_type]", BELAIR_TEST_.test_payment_type);
    body.set("payment[value][currency]", BELAIR_TEST_.test_currency);
    body.set("payment[value][payOption]", BELAIR_TEST_.test_payOption);

    return this.http.flightsave(`b2c/booking/payment`, body)
  }
}
